import { NgModule } from '@angular/core';
import { NgxInitDirective } from './ngx-init.directive';

@NgModule({
  declarations: [NgxInitDirective],
  exports: [NgxInitDirective]
})
export class NgxInitModule {}
